// types
import { IAlert } from "../defs/Alert";
import { SEVERITY } from "../defs/Severity";

export enum ErrorEnum {
    SERVER_ERROR = "SERVER_ERROR",
    UNAUTHORIZED = "UNAUTHORIZED",
    QUICKSIGHT_ERROR = "QUICKSIGHT_ERROR",
    MISSING_SIMULATION_PARAMETERS = "MISSING_SIMULATION_PARAMETERS",
    RESOURCE_NOT_FOUND = "RESOURCE_NOT_FOUND",
    SIMULATION_ALREADY_DELETED = "SIMULATION_ALREADY_DELETED",
    SIMULATION_ALREADY_STARTED_OR_FINISHED = "SIMULATION_ALREADY_STARTED_OR_FINISHED",
    SANDBOX_LIMIT_REACHED = "SANDBOX_LIMIT_REACHED",
    SIMULATION_ALREADY_QUEUED = "SIMULATION_ALREADY_QUEUED",
    JOURNAL_ENTRIES_ERROR = "JOURNAL_ENTRIES_ERROR",
    UPLOAD_ERROR = "UPLOAD_ERROR",
    INVALID = "INVALID",
    VALIDATION_ERROR = "VALIDATION_ERROR",
    EXPORT_ERROR = "EXPORT_ERROR",
    APPLY_PAST_DRIVER_FAILED = "APPLY_PAST_DRIVER_FAILED",
    REFETCH_CUSTOM_DRIVER_LIST_FAILED = "REFETCH_CUSTOM_DRIVER_LIST_FAILED",
    FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED",
    SIMULATION_SHARING_FAILED = "SIMULATION_SHARING_FAILED",
    SIMULATION_PUBLISH_FAILED = "SIMULATION_PUBLISH_FAILED",
    SIMULATION_LIST_LOAD_FAILED = "SIMULATION_LIST_LOAD_FAILED",
    CUSTOM_DRIVER_LIST_LOAD_FAILED = "CUSTOM_DRIVER_LIST_LOAD_FAILED",
}

export const SOMETHING_WENT_WRONG_ERROR_MESSAGE = "Something went wrong";

export const ERROR_MESSAGE: { [key: string]: IAlert } = {
    [ErrorEnum.SERVER_ERROR]: {
        title: SOMETHING_WENT_WRONG_ERROR_MESSAGE,
        content: "Server could not be reached. Try again or reload.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.UNAUTHORIZED]: {
        // TODO: Added temporary wording, will replace it with the correct wording and permission SOPs.
        title: "Permission Required",
        content: "Permission required. Please raise a ticket.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.QUICKSIGHT_ERROR]: {
        title: SOMETHING_WENT_WRONG_ERROR_MESSAGE,
        content: "Loading report failed. Refresh page or try again.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.RESOURCE_NOT_FOUND]: {
        title: "Resource not found",
        content: "loading resource. Refresh page or try again.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.SIMULATION_ALREADY_DELETED]: {
        title: "Unable to delete the simulation",
        content: "Simulation is already deleted",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.SIMULATION_ALREADY_STARTED_OR_FINISHED]: {
        title: "Unable to start the simulation",
        content: "Simulation is already already started or finished",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.SANDBOX_LIMIT_REACHED]: {
        title: "Unable to start a new simulation",
        content: "A maximum of only 2 active simulations can run at a time.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.JOURNAL_ENTRIES_ERROR]: {
        title: " error(s) found",
        content: "Inputs do not match system information.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.UPLOAD_ERROR]: {
        title: "Invalid File Format",
        content: "Excel File Incorrect. Please upload again using the required format",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.INVALID]: {
        title: "Invalid Data",
        content: "Invalid file format", // This will be overridden in useEffect based on attributes
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.VALIDATION_ERROR]: {
        title: "Validation Failed",
        content: "Validation Process Failed. Refresh page or try again.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.EXPORT_ERROR]: {
        title: "Upload Failed",
        content: "File Upload Process Failed. Refresh page or try again.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.APPLY_PAST_DRIVER_FAILED]: {
        title: "Apply a past driver failed",
        content: "Please try again.",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.REFETCH_CUSTOM_DRIVER_LIST_FAILED]: {
        title: "Refetch of custom driver failed",
        content: "Please refresh the page",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.FILE_UPLOAD_FAILED]: {
        title: "File upload failed, Please try again",
        content: "Please try again",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.SIMULATION_SHARING_FAILED]: {
        title: "Simulation sharing failed",
        content: "Please try again",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.SIMULATION_PUBLISH_FAILED]: {
        title: "Simulation publish failed",
        content: "Please try again",
        severity: SEVERITY.ERROR,
        autoTimeout: 6000,
    },
    [ErrorEnum.SIMULATION_LIST_LOAD_FAILED]: {
        title: "Error loading the simulations.",
        content: "Please try again",
        severity: SEVERITY.ERROR,
        autoTimeout: 0,
    },
    [ErrorEnum.CUSTOM_DRIVER_LIST_LOAD_FAILED]: {
        title: "Error loading the custom drivers.",
        content: "Please try again",
        severity: SEVERITY.ERROR,
        autoTimeout: 0,
    },
};
